module.exports = __webpack_public_path__ + "img/arrow_down.555a72b5.svg";